import { GridToolbarExportContainer, GridCsvExportMenuItem, GridPrintExportMenuItem } from '@mui/x-data-grid-pro';
import { ExportMenuItem } from './ExportMenuItem';

export function ExportMenu(props) {
    const { options } = props;

    return (
        <GridToolbarExportContainer {...props} >
            <GridCsvExportMenuItem options={{fileName:`${options?.fileName? options.fileName: "report"}_csv`}}/>
            <ExportMenuItem options={{fileName:`${options?.fileName? options.fileName: "report"}_excell`}}/>
        </GridToolbarExportContainer>
    );
}
